<template>
    <Transition name="toast-fade">
        <!-- class toast에 toast_err 혹은 toast_scs 추가시 에러, 성공 토스트 출력가능 -->
        <div class="toast" v-if="toast.isShow">
            <pre style="text-align: center;">{{toast.text}}</pre>
        </div>
    </Transition>
</template>


<script>
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState(['toast'])
    },
    methods: {

    }
}
</script>


<style scoped>

</style>
